import React from 'react'
import { useParams } from 'react-router-dom'
import useQuery from '../useQuery'
import PageFilters from './components/PageFilters'
import GetTicketsIssuedByTagValueWidget from './GetTicketsIssuedByTagValueWidget'
import GetTicketsIssuedByTagWidget from './GetTicketsIssuedByTagWidget'

const DEFAULT_TAGS = ['Ticket Pool', 'Ticket Type']
const DEFAULT_TAG_KEY = 'Ticket Pool'

const TicketsIssued = ({ event }) => {
    const { id: eventId } = useParams()
    const {
        startDate = null,
        endDate = null,
        tags = DEFAULT_TAGS,
        tagKey = DEFAULT_TAG_KEY,
    } = useQuery()

    return (
        <div>
            <PageFilters
                startDate={startDate}
                endDate={endDate}
                tags={tags}
                event={event}
                eventId={eventId}
            />
            <div className="wrapper wrapper-content">
                <div className="animated fadeIn">
                    <div style={{ marginTop: -15, paddingTop: 0 }}>
                        <GetTicketsIssuedByTagValueWidget
                            startDate={startDate}
                            endDate={endDate}
                            event={event}
                            eventId={eventId}
                            tagKeyName={tagKey}
                        />

                        <GetTicketsIssuedByTagWidget
                            startDate={startDate}
                            endDate={endDate}
                            eventId={eventId}
                            tags={Array.isArray(tags) ? tags : [tags]}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TicketsIssued
